import React, { useState, useEffect } from 'react';
//import './HeaderSort.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { Popover } from 'react-tiny-popover';

function ListOpen(props) {
	const {
		column,
		listItem
	} = props;

	return (
		<div key={column.key} className={`item__cell ${column.key}`}>
			{column.render(listItem)}
		</div>
	);
}

export default ListOpen;
